import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Home from './Home';
import { RatesAndAvailability } from './RatesAndAvailability';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Spinner from 'react-bootstrap/Spinner';

export default function Load(props) {

    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const { propertyName } = useParams();

    const[property, setProperty] = useState();
    const[promotions, setPromotions] = useState();
    const [roomTypes, setRoomTypes] = useState();
    const [closedDates, setClosedDates] = useState();

    useEffect(() => {

        storeTrackingData();
        getProperty();

    }
        , []);

    useEffect(() => {

        if (property && promotions && roomTypes && closedDates) setLoading(false);

    }, [property, promotions, roomTypes, closedDates])

    function storeTrackingData() {
        const params = new URLSearchParams(location.search);

        const utm = {
            source: params.get('utm_source'),
            medium: params.get('utm_medium'),
            campaign: params.get('utm_campaign'),
            referrer: document.referrer || '',
            landingPage: window.location.href
        };

        // Only overwrite if we actually have a tagged source
        if (utm.source) {
            localStorage.setItem('bookingUtm', JSON.stringify(utm));
            console.log('Stored UTM:', utm);
        } else {
            // Optional fallback: store referrer if no UTM exists and nothing stored yet
            const existing = localStorage.getItem('bookingUtm');
            if (!existing) {
                const fallback = {
                    source: 'direct',
                    medium: 'none',
                    campaign: '',
                    referrer: document.referrer || '',
                    landingPage: window.location.href
                };

                if (document.referrer) {
                    try {
                        const refUrl = new URL(document.referrer);
                        fallback.source = refUrl.hostname;
                        fallback.medium = 'referral';
                    } catch { }
                }

                localStorage.setItem('bookingUtm', JSON.stringify(fallback));
                console.log('Stored fallback tracking:', fallback);
            }
        }
    }

    function getPromotions(property) {
        let url = 'api/promotions?propertyKey=' + property.key;
        fetch(url)
            .then((response) => {
                return response.json();
            })
            .then(data => {
                console.log('Promotions: ' + data);

                var p = convertDateStringsToDateObjects(data);

                    setPromotions(p);

                //this.props.setPromotions(data);

            }).catch(error => {
                console.log(error);
        });

    }

    // Function to convert date strings to Date objects
    function convertDateStringsToDateObjects(promotionsArray) {
        return promotionsArray.map(function (promotion) {
            return {
                id: promotion.id,
                name: promotion.name,
                dateFrom: new Date(promotion.dateFrom),
                dateTo: new Date(promotion.dateTo)
            };
        });
    }

    function getRoomTypes(property) {
        let url = 'api/roomTypes?propertyKey=' + property.key;
        fetch(url)
            .then((response) => {
                return response.json();
            })
            .then(data => {
                console.log('RoomTypes: ' + data);
                setRoomTypes(data);

                //this.props.setRoomTypes(data);

            }).catch(error => {
                console.log(error);
            });
    }

    function getClosedDates(property) {
        let url = 'api/closedDates?propertyKey=' + property.key;
        fetch(url)
            .then((response) => {
                return response.json();
            })
            .then(data => {
                console.log('closedDates: ' + data);
                setClosedDates(data);
                              

                //this.props.setClosedDates(data);
            }).catch(error => {
                console.log(error);
            });

    }

    function getProperty() {
        //if ((id === '/Home') || (id === '/RatesAndAvailability')) { return; }

        let url = 'api/property?id=' + propertyName;

            fetch(url)
                .then((response) => {
                    return response.json();
                })
                .then(data => {
                    console.log(data);
                    console.log(data.propertyDescription);
                    
                    //props.setProperty(data);
                    setProperty(data);

                    getPromotions(data);
                    getRoomTypes(data);
                    getClosedDates(data);

                }).catch(error => {
                    console.log(error);
                });

        
    }

    function convertDate(date) {
        return new Date(date + "Z");
    }

    
    return (
        <div>
            {loading ?
                <div className="d-flex justify-content-center align-items-center spinner-container">
                <p>Please wait while we search for available rooms. </p>
                <p><Spinner animation="border" variant="primary" /></p>
                </div>
                :
                <div>
                    <ReactTooltip />
                    {
                        (property && promotions && roomTypes && closedDates &&
                            <RatesAndAvailability
                                propertyName={property.name}
                                propertyId={property.id}
                                propertyKey={property.key}
                                propertyWebsite={property.website}
                                propertyPayment={property.payment}
                                promotions={promotions}
                                roomTypes={roomTypes}
                                closedDates={closedDates}

                            />)}</div>}
        </div>
    );
    
}